/** @module Classes */ /** typedoc */
/**
 * Represents an object witch allows to build a Public URL
 */
class SocialPublicUrl {
    /**
     * Create a social public url with at least an url and a path.
     * @param {string} url the baseUrl of the public social service (ex : `https://artist.landr.com`
     * @param {string} path the path to the public resource (ex: for a release it will be `/music`)
     * @param {string} param the url param if needed (ex: for a release it will be the upcCode)
     */
    constructor(url, path, param) {
        this.url = url;
        this.path = path;
        this.param = param;
    }
}
/**
 * Represent a DSP External URl object
 */
class SocialExternalUrl {
    /**
     * Create a Social External URl with at least a dspName.
     * @param {string} dspName
     * @param {string} url the url provided by the Dsp Provider
     */
    constructor(dspName, url) {
        this.dspName = dspName;
        this.url = url;
    }
}

export { SocialExternalUrl, SocialPublicUrl };
